import ProductCardSkeleton from './ProductCardSkeleton'
export default ProductCardSkeleton
